export const applyItemOptimisticImage = (setCache, listId, itemId, base64Data) => {
  setCache((current) => ({
    ...current,
    items: {
      ...current.items,
      [listId]: (current.items[listId] || []).map((it) =>
        it.id === itemId
          ? {
              ...it,
              images: {
                primary: {
                  id: 'temp-' + Date.now(),
                  thumbnailUrl: base64Data,
                  mediumUrl: base64Data,
                  uploadedAt: new Date(),
                  isOptimistic: true,
                },
              },
            }
          : it
      ),
    },
  }));
};

export const revertItemOptimisticImage = (setCache, listId, itemId) => {
  setCache((current) => ({
    ...current,
    items: {
      ...current.items,
      [listId]: (current.items[listId] || []).map((it) =>
        it.id === itemId
          ? {
              ...it,
              images: null,
            }
          : it
      ),
    },
  }));
};


